import script from "./DashboardWidget.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardWidget.vue?vue&type=script&lang=ts&setup=true"

import "./DashboardWidget.vue?vue&type=style&index=0&id=3065acdb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3065acdb"]])

export default __exports__